import { render, staticRenderFns } from "./RemindModalV2.vue?vue&type=template&id=35ae7fdc&scoped=true&"
import script from "./RemindModalV2.vue?vue&type=script&lang=js&"
export * from "./RemindModalV2.vue?vue&type=script&lang=js&"
import style0 from "./RemindModalV2.vue?vue&type=style&index=0&id=35ae7fdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae7fdc",
  null
  
)

export default component.exports